import React from 'react';

export default class FancyRadio extends React.Component {
  render() {
    return (
      <div className={`fancy-radio ${this.props.className ? this.props.className : ''}`}>
        <input type="radio" id={this.props.id} name={this.props.name} checked={this.props.checked} disabled={this.props.disabled} />
        <label htmlFor={this.props.id}>
          <span className="radio"></span>
          {this.props.text}
        </label>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/form/fancyRadio.js